import { useState } from 'react'
import { ShopPage } from './ShopPage'
import { FormPage } from './FormPage'
import { ThanksPage } from './ThanksPage'

function FredriksonShop() {
  const [step, setStep] = useState(Number(window.localStorage.getItem('School-step')) || 1)

  const nextStep = () => {
    setStep((step) => step + 1)
  }

  const setPage = (number: number) => {
    setStep(number)
  }

  console.log(step)

  return (
    <>
      {step === 0 && <ShopPage nextStep={nextStep} />}
      {step === 1 && <ShopPage nextStep={nextStep} />}
      {step === 2 && <FormPage setPage={setPage} nextStep={nextStep} />}
      {step === 3 && <ThanksPage />}
    </>
  )
}

export default FredriksonShop
